import { createContext, useContext, useState } from "react";

/**
 * @param {boolean} setShowMainPageMask 是否顯示遮罩
 * @param {function} showMainPageMask 設定遮罩顯示狀態的函式
 */
export interface MainPageMaskContextInterface {
    setShowMainPageMask: (show: boolean) => void;
    showMainPageMask: boolean;
}

export const MainPageMaskContext = createContext<MainPageMaskContextInterface>({
    setShowMainPageMask: () => { },
    showMainPageMask: false,
});

export const MainPageMaskProvider = ({ children }: { children: React.ReactNode }) => {
    const [showMainPageMask, setShowMainPageMask] = useState(false);

    return (
        <MainPageMaskContext.Provider value={{ showMainPageMask, setShowMainPageMask }}>
            {children}
        </MainPageMaskContext.Provider>
    );
};

export const WithMainPageMaskContext = (Component: React.ComponentType<any>) => {
    const WrappedWithContext = (props: any) => {
        const context = useContext(MainPageMaskContext);
        return <Component {...props} {...context} />;
    };
    return WrappedWithContext;
};
